module.exports = __webpack_public_path__ + "static/media/cat-lg-4.300e51b5.jpg";